import React from 'react';
import { useFormikContext, useField } from "formik";
import { ROLES } from "./constants";

const RolesBuilder = () => {
  const { setFieldValue } = useFormikContext();
  const [field, , helpers] = useField('roles');

  const handleCheckboxChange = (key, isChecked) => {
    if (isChecked) {
      helpers.setValue([...field.value, key]);
    } else {
      helpers.setValue(field.value.filter(item => item !== key));
    }
  };

  return (
    <div className="flex flex-col w-full">
      <h3 className="text-3xl">What roles do you need?</h3>
      <p>Select the areas you want Huddle builders to support.</p>
      <div className="mt-5 flex space-x-2">
        {Object.entries(ROLES).map(([key, { title }]) => (
          <label key={key} className="flex space-x-2 items-center justify-center p-3 rounded-xl border border-gray-200 cursor-pointer">
            <input
              id={`checkbox-${key}`} // TODO: FIX
              className="w-5 h-5 text-huddleBlack bg-white rounded focus:ring-huddleBlack focus:ring-2"
              type="checkbox"
              checked={field.value.includes(key)}
              onChange={(e) => handleCheckboxChange(key, e.target.checked)}
            />
            <span className="flex-1">{title}</span>
          </label>
        ))}
      </div>
    </div>
  )
}

export default RolesBuilder;
